import { EHeadingStyleVariant, Heading } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import MapImage from '@/assets/escapes/map.png';
import ResponsiveImage from '@/components/utility/ResponsiveImage/ResponsiveImage';

export const MapSection = () => {
  return (
    <div className="flex flex-col items-center md:flex-row gap-5 md:gap-10 mt-7">
      <div className="flex flex-col w-full gap-5 md:w-[70%] xl:w-[80%]">
        <ResponsiveImage src={MapImage.src} className="w-full h-full" />
      </div>
      <div className="flex flex-col w-full text-center gap-5 md:w-[30%] xl:w-[20%] md:text-left">
        <Heading
          variant={EHeadingStyleVariant.H2}
          className="italic font-normal !font-[abril-titling] text-[48px] md:text-[64px] lg:text-[76px]">
          <FormattedMessage defaultMessage="Explore. Book. Enjoy." id="pLwCDF" />
        </Heading>
      </div>
    </div>
  );
};
